import { Base } from "@tt-app/api/base";
import { API_ENDPOINTS } from "@tt-app/constants/api";
import { RELEASE_NOTE_SCOPES } from "@tt-app/constants/releaseNotes";
import { AxiosResponse } from "axios";
import { PaginatedReleaseNotes } from "@tt-app/types/releaseNotes";

const {
  RELEASE_NOTES: { LIST }
} = API_ENDPOINTS;

export class ReleaseNotes extends Base {
  /**
   * @param page to fetch from paginated release notes.
   * @returns A paginated list of Release Note objects to be used with ttui-release-note
   *
   * "page_size" parameter excluded, but can be added if we need shorter/longer pages.
   * SCOPE is hard-coded to TT4W. Other release note scopes exist, but don't need to be shown here.
   */
  async releaseNotes(page: string): Promise<AxiosResponse<PaginatedReleaseNotes>> {
    return this.httpClient.get(LIST, {
      params: { page, scope: RELEASE_NOTE_SCOPES.TT4W }
    });
  }
}
